import { encryptJsonToQ } from '@/utils/crypto_helpers';
import { generateRequestHeader } from '@/utils/axiosUtils';

const latin1Safe = (s: string) => s.replace(/[^\x00-\xFF]/g, '');

/** Encrypted GET URL + headers matching `config/http.ts` for worker `fetch`. */
export async function buildEncryptedGetUrlAndHeaders(
	path: string,
	params: Record<string, string | number | boolean>,
): Promise<{ url: string; headers: Record<string, string> }> {
	const baseURL = import.meta.env.VITE_COMMON_URL;
	const normalizedPath = path.startsWith('/') ? path : `/${path}`;
	const queryHashed = await encryptJsonToQ(params);
	const refHeader = await generateRequestHeader(1);
	const auditData =
		typeof localStorage !== 'undefined'
			? localStorage.getItem('auditUser') || '{}'
			: '{}';

	const url = `${baseURL}${normalizedPath}?queryHashed=${encodeURIComponent(queryHashed)}&qv=1`;

	const headers: Record<string, string> = {
		'x-ref-id': encodeURI(refHeader),
		'x-audit-user': latin1Safe(auditData),
	};

	return { url, headers };
}
